import React, { useContext, useState, useEffect, Fragment } from "react";
import { Store } from "../state/state";
import { useObserver } from "mobx-react";

import SettingDefault from "./Setting/SettingDefault";
import SettingElse from "./Setting/SettingElse";
import { toJS } from "mobx";
import Buttoon from "../common/Buttoon";
import SaveCalendar from "./Templates/Calender/SaveCalendar";
import OverlayDownload from "./Setting/OverlayDownload";

function SettingPart() {
  const [openSaveTheme, setOpenSaveTheme] = useState(false);
  const [openDownload, setOpenDownload] = useState(false);

  const store = useContext(Store);
  useEffect(() => {
    let settingUI = document.querySelector("#setting-part");
    let settingScroll = document.querySelector("#scroll-setting");
    settingUI.addEventListener("click", (e) => {
      console.log("======");
      const id = e.target.getAttribute("id");
      console.log("id :", id);
      console.log("edtior :", toJS(store.selectEditor));
      if (id === "setting-part") store.selectEditor = "";
      else if (id !== store.selectEditor)
        store.selectEditor = e.target.getAttribute("id");
    });
    settingScroll.addEventListener("scroll", (e) => {
      store.selectEditor = "";
      store.scrollTop = settingScroll.scrollTop;
    });
  }, []);
  let { theme } = store;
  return useObserver(() => (
    <Fragment>
      <div
        id="setting-part"
        className="fixed z-50 right-0 duration-500 transition-transform"
        style={{
          width: "15vw",
          // width: store.preview ? "0vw" : "30vw",
          transform: store.preview ? "translateX(15vw)" : "translateX(0px)",
        }}
      >
        <div
          className="w-full shadow-xl flex flex-col  h-screen 
         transition-all duration-500  max-w-3xl  "
        >
          <div
            className="w-16 h-16 bg-white  rounded-l fixed flex-col 
             flex items-center  justify-center
            cursor-pointer hover:bg-gray-100 transition-all duration-500"
            style={{
              right: "100%",
              // right: !store.preview ? "30vw" : "0vw",
              top: 0,
              height: "70px",
            }}
            onClick={() => store.onPreview()}
          >
            <img
              src={require("../assest/icon-arrow.png")}
              className={`  transition-all duration-500 text-xl text-black`}
              style={{
                height: "2vh",
                transform: !store.preview ? "rotate(270deg)" : "rotate(0deg)",
              }}
            ></img>
            {!store.preview && (
              <div
                className="h-16 w-5 bg-secondary rounded-full mt-1"
                style={{ height: "5px" }}
              ></div>
            )}
          </div>
          {/* <h1
        className="text-4xl text-center font-mono font-black text-gray-800 shadow-xl w-full"
        style={{ height: "50px" }}
      >
        Calender Maker <span className="fa fa-calendar-alt"></span>
      </h1> */}
          <hr />
          {/* <ChromePicker
        color={store.theme.header.backgroundColor}
        onChange={(color) => store.setHeaderColor(color.hex)}
      /> */}
          <div className="flex justify-center items-center h-56 w-full bg-white">
            <img
              src={require("../assest/icon-calender(black).png")}
              alt=""
              style={{ width: "3vw" }}
            />
          </div>
          <div
            className=" flex-1 overflow-auto relative px-2  bg-white"
            id="scroll-setting"
            style={{
              width: "15vw",
              // transform: store.preview ? "translateX(30vw)" : "translateX(0vw)",
            }}
          >
            {store.select ? (
              <SettingElse select={store.select} />
            ) : (
              <SettingDefault />
            )}
          </div>
        </div>
      </div>
      <div className="h-full flex flex-col items-end" style={{ width: "30vw" }}>
        <div
          className="flex-1 flex  flex-col justify-center items-center "
          style={{ width: "20vw" }}
        >
          <Buttoon
            onClick={() => {
              setOpenSaveTheme(true);
            }}
            className="mb-10 "
          >
            حفظ
          </Buttoon>
          <Buttoon
            onClick={() => {
              setOpenDownload(true);
              store.resizeTemplate = false;
            }}
          >
            تنزيل
          </Buttoon>
        </div>
        <div className="flex-1 flex relative " style={{ width: "20vw" }}>
          <img
            className="hidden md:block absolute right-0 z-20 top-0  "
            src={require("../assest/block-right.png")}
            style={{
              width: "170px",
              top: "50px",
              filter: store.preview ? "blur(5px)" : "blur(0px)",
            }}
          />
        </div>
        <SaveCalendar
          onClose={() => setOpenSaveTheme(false)}
          title="حفظ المظهر"
          open={openSaveTheme}
        />
        <OverlayDownload
          onClose={() => {
            setOpenDownload(false);
            store.resizeTemplate = true;
            console.log("close ");
          }}
          open={openDownload}
        />
      </div>
    </Fragment>
  ));
}

export default SettingPart;
